// extracted by mini-css-extract-plugin
export var dividerContainer = "_7y-0";
export var line = "_7y-1";